<template>
    <ul :id="`tree-node-actions-${node.id} `">
      <li
        class="a-tooltip-primary a-tooltip-bottom"
        :data-tooltip-text="!node.oculto ? 'Contenido visible' : 'Contenido NO visible'"
      >
        <small><i :class="!node.oculto ? 'fa fa-eye' : 'fa fa-eye-slash'"></i></small>
      </li>
      <li
        class="a-tooltip-primary a-tooltip-bottom"
        :data-tooltip-text="!node.oculto ? 'Contenido visible' : 'Contenido NO visible'"
      >
      </li>
      <li>
        <div
          v-show="!node.children.length"
          class="m-dropdown-sublist"
        >
        <li>
          <input
            v-model="visto"
            type="checkbox"
            name="medio"
            @change="setVisto"
          >
        </li>
      </div>

      </li>
    </ul>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetContentsTreeNodeActions',

  props: {
    contenido: Object,
    node: Object
  },

  data () {
    return {
      visto: ''
    }
  },

  computed: {
    nodeLength () {
      return this.node.children ? this.node.children.length : 0
    }
  },

  methods: {
    editNode () {
      this.$router.push(`/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.contents.subject')}/${this.node.id}/${this.$t('mEditionMenu.asset.contents.children.editor2.subedition')}`)
    },

    setVisto () {
      this.$emit('upload-visto', this.visto)
    }
  }
}
</script>
